import { render, staticRenderFns } from "./DeliveredIcon.vue?vue&type=template&id=a85096c6"
import script from "./DeliveredIcon.vue?vue&type=script&lang=js"
export * from "./DeliveredIcon.vue?vue&type=script&lang=js"
import style0 from "./DeliveredIcon.vue?vue&type=style&index=0&id=a85096c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports